import AppListing from '../app-components/Listing/AppListing';

Vue.component('app-payment-trasaction-listing', {
    mixins: [AppListing],
    data: function () {  
        return {
            showFilter: false,
            moduleFilters:{
                date_start: null,
                date_end: null,
                weight_date_start: null,
                weight_date_end: null,
            },
            tempWeightdate: null
        }
    },
    methods:{
        onChangeWeightDateRangeFilter(dateRange){
            console.log('onChangeWeightDateRangeFilter')
            if (dateRange) {
                this.moduleFilters.weight_date_start = this.formatDate(dateRange[0], null, this.dateFormat.ymdhis)
                this.moduleFilters.weight_date_end = this.formatDate(dateRange[1], null, this.dateFormat.ymdhis)
            }else{
                this.moduleFilters.weight_date_start = null
                this.moduleFilters.weight_date_end = null
            }
            this.applyFilters()
        },
    }
});